import React, { useEffect, useState } from "react";
import SingleSelectButtonGroup from "../Partner/SingleSelectButtonGroup";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { marketingInvestmentOptions } from "../../constants/dataConstants";
import SingleSelectButtonGroupWithAddItem from "../Partner/SingleSelectButtonGroupWithAddItem";

interface Props {
  setDefaultTab: (tab: string) => void;
  selectedEngagementModel: string;
  setSelectedEngagementModel: (model: string) => void;
  selectedExclusivityTenure: string;
  setSelectedExclusivityTenure: (tenure: string) => void;
  selectedFobCifPreference: string;
  setSelectedFobCifPreference: (preference: string) => void;
  selectedMarketingInvestment: string;
  setSelectedMarketingInvestment: (investment: string) => void;
  engagementTerms: any;
}

const EngagementTerms = (props: Props) => {
  const {
    selectedEngagementModel,
    setSelectedEngagementModel,
    selectedExclusivityTenure,
    setSelectedExclusivityTenure,
    selectedFobCifPreference,
    setSelectedFobCifPreference,
    selectedMarketingInvestment,
    setSelectedMarketingInvestment,
    engagementTerms,
  } = props;

  const navigate = useNavigate();

  const [engagementModelChecked, setEngagementModelChecked] = useState(true);

  const [exclusivityTenureChecked, setExclusivityTenureChecked] =
    useState(true);

  const [fobCifPreferenceChecked, setFobCifPreferenceChecked] = useState(true);

  const [marketingInvestmentChecked, setMarketingInvestmentChecked] =
    useState(true);

  useEffect(() => {
    if (
      engagementTerms &&
      typeof engagementTerms === "object" &&
      Object.keys(engagementTerms)?.length > 0
    ) {
      setSelectedEngagementModel(engagementTerms.engagement_model[0]);
      setSelectedExclusivityTenure(engagementTerms.exclusivity_tenure);
      setSelectedFobCifPreference(engagementTerms.fob_preference[0]);
      setSelectedMarketingInvestment(engagementTerms.marketing_investments);
    }
  }, [engagementTerms]);

  const handleSaveAndContinue = () => {
    if (!selectedEngagementModel) {
      message.error("Please select a value for Engagement Model.");
      return;
    }
    if (!selectedExclusivityTenure) {
      message.error("Please select a value for Exclusivity Tenure.");
      return;
    }
    if (!selectedFobCifPreference) {
      message.error("Please select a value for FOB/CIF Preference.");
      return;
    }
    if (!selectedMarketingInvestment) {
      message.error("Please select a value for Marketing Investment.");
      return;
    }
    props.setDefaultTab("expansion-setup");
  };

  return (
    <div className="p-6 bg-[#F9FAFB] min-h-screen">
      <div className="flex flex-col gap-[32px] max-w-[797px] ">
        <SingleSelectButtonGroup
          label="Engagement Model "
          options={["Pre-Purchase", "Consignment", "Both"]}
          selected={selectedEngagementModel}
          setSelected={setSelectedEngagementModel}
          checked={engagementModelChecked}
          setChecked={setEngagementModelChecked}
        />
        <SingleSelectButtonGroupWithAddItem
          label="Exclusivity Tenure  "
          options={["2 years", "3 years", "4 years", "5 years", "Other"]}
          selected={selectedExclusivityTenure}
          setSelected={setSelectedExclusivityTenure}
          checked={exclusivityTenureChecked}
          setChecked={setExclusivityTenureChecked}
        />
        <SingleSelectButtonGroupWithAddItem
          label="FOB/CIF Preference"
          options={["FOB", "CIF", "Other"]}
          selected={selectedFobCifPreference}
          setSelected={setSelectedFobCifPreference}
          checked={fobCifPreferenceChecked}
          setChecked={setFobCifPreferenceChecked}
        />
        <SingleSelectButtonGroupWithAddItem
          label="Marketing Investment"
          options={marketingInvestmentOptions}
          selected={selectedMarketingInvestment}
          setSelected={setSelectedMarketingInvestment}
          checked={marketingInvestmentChecked}
          setChecked={setMarketingInvestmentChecked}
        />
      </div>
      <div className="flex justify-end pt-[50px]">
        <Button className="mr-2" onClick={() => navigate(-1)}>Cancel</Button>
        <Button
          onClick={handleSaveAndContinue}
          className="!bg-[#24a0ed]"
          type="primary"
        >
          Save & Continue
        </Button>
      </div>
    </div>
  );
};

export default EngagementTerms;
